const initialState = {
  workspacesLoading: false,
};

const loaders = (state = initialState, action) => {
  switch (action.type) {
    case 'WORKSPACES_GET_REQUEST':
      return { ...state, workspacesLoading: true };
    case 'WORKSPACES_GET_RESPONSE':
      return { ...state, workspacesLoading: false };
    default:
      return state;
  }
};

export default loaders;
